import { FetchAddressesPayload, fetchAddresses, deleteAddress, addAddress, undoDeleteAddress, updateAddress } from './actions'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { AddressBook, initAddressBookState, Address } from './state'

const mapPayloadToAddresses = (payload: FetchAddressesPayload): Array<Address> => {
   
    if (!payload.contact) {
        return []
    }
    return payload.contact
}

export const reducer = reducerWithInitialState<AddressBook>(initAddressBookState())
    .case(fetchAddresses.async.started, (state) => ({ ...state, fetching: true }))
    .case(fetchAddresses.async.failed, (state) => ({ ...state, fetching: false, error: true }))
    .case(fetchAddresses.async.done, (state, { params, result }) => {
        return {
            ...state,
            fetching: false,
            error: false,
            addresses: mapPayloadToAddresses(result)
        }    
    })

    .case(deleteAddress.async.started, (state, { addressId }) => {
        return {
            ...state,
            fetching: true,
            addresses : state.addresses?.map(
                address =>
                    address.addressId === addressId
                        ? {
                              ...address,
                              loading: true
                          }
                        : address
            ),
        }
    })
    .case(deleteAddress.async.failed, (state, { params: { addressId } }) => ({
        ...state,
        fetching: false,
        addresses: state.addresses?.map(
            address =>
                addressId === address.addressId
                ? {
                    ...address,
                    loading: false,
                    loadError: true
                }
                : address
        )
    }))
    .case(deleteAddress.async.done, (state, { params: { addressId } }) => {
        return {
            ...state,
            fetching: false,            
            addresses: state.addresses?.map(
                address =>
                    address.addressId === addressId
                        ? {
                              ...address,
                              loading: false,
                              isDeleted: true
                          }
                        : address
            )
        }
    })
    .case(undoDeleteAddress.async.started, (state, { addressId }) => {
        return {
            ...state,
            fetching: true,
            addresses : state.addresses?.map(
                address =>
                    address.addressId === addressId
                        ? {
                              ...address,
                              loading: true
                          }
                        : address
            ),
        }
    })
    .case(undoDeleteAddress.async.failed, (state, { params: { addressId } }) => {
        return {
            ...state,
            fetching: false,
            addresses: state.addresses?.map(
                address =>
                    addressId === address.addressId
                    ? {
                        ...address,
                        loading: false,
                        loadError: true
                    }
                    : address
            )
        }
    })
    .case(undoDeleteAddress.async.done, (state, { params: { addressId }, result }) => {
        return {
            ...state,
            fetching: false,
            addresses: state.addresses?.map(
                address =>
                    address.addressId === addressId
                        ? {
                              ...address,
                              loading: false,
                              isDeleted: false,
                              addressId: result.addressId
                          }
                        : address
            )
        }
    })

    .case(addAddress.async.started, (state) => ({ ...state, fetching: true }))
    .case(addAddress.async.failed, (state) => {
        return {
            ...state,
            fetching: false,
            error: true
        }    
    })
    .case(addAddress.async.done, (state, { params, result }) => {

        return {
            ...state,
            fetching: false,
            error: false,
            addresses: [...(state.addresses || []), {...params.address, addressId: result.addressId}] 
        }    
    })
    .case(updateAddress.async.started, (state, { addressId }) => {
        return {
            ...state,
            fetching: true,
            addresses : state.addresses?.map(
                address =>
                    address.addressId === addressId
                        ? {
                              ...address,
                              loading: true
                          }
                        : address
            ),
        }
    })
    .case(updateAddress.async.failed, (state, { params: { address: { addressId }} }) => {
        return {
            ...state,
            fetching: false,
            addresses : state.addresses?.map(
                address =>
                    address.addressId === addressId
                        ? {
                              ...address,
                              loading: false,
                              loadError: true
                          }
                        : address
            ),
        }        
    })
    .case(updateAddress.async.done, (state, { params, result }) => {
        return {
            ...state,
            fetching: false,
            addresses : state.addresses?.map(
                address =>
                    address.addressId === params.address?.addressId
                        ? {
                            ...params.address, 
                            addressId: result.addressId,
                            loading: false
                          }
                        : address
            ),
        }
        
    })

    .build()


